import axios, { type AxiosInstance } from "axios";
import { getExhibitionHeader, type StoredExhibition } from "../utils/exhibitionContext";

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  Object.assign(config.headers, getExhibitionHeader());
  return config;
});

export interface SwitcherResponse {
  current_exhibition_id: number | null;
  exhibitions: StoredExhibition[];
  total: number;
}

const ExhibitionSwitcherService = {
  /**
   * Fetch all exhibitions with a flag marking the one currently active
   * for this request (resolved by the backend middleware).
   */
  async getSwitcherList(): Promise<SwitcherResponse> {
    const res = await api.get<SwitcherResponse>(
      "/api/exhibitions/exhibitions/switcher/"
    );
    return res.data;
  },

  /**
   * Returns only exhibitions that are still open (status === true).
   * Used by non-superuser clients for switching.
   */
  async getActiveExhibitions(): Promise<StoredExhibition[]> {
    const data = await this.getSwitcherList();
    return data.exhibitions.filter((ex) => ex.status === true);
  },

  /**
   * Returns all exhibitions (active + closed).
   * Used by superusers who need full control.
   */
  async getAllExhibitions(): Promise<StoredExhibition[]> {
    const data = await this.getSwitcherList();
    return data.exhibitions;
  },
};

export default ExhibitionSwitcherService;
